"use client";

import { type PropsWithChildren } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { env } from "@/env";

export const GoogleReCaptchaView = ({ children }: PropsWithChildren) => (
    <GoogleReCaptchaProvider reCaptchaKey={env.NEXT_PUBLIC_RECAPTCHA_KEY}>
        {children}
    </GoogleReCaptchaProvider>
);
